// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"268":"Home","994":"Slidr"}[chunkId] || chunkId) + "." + {"141":"800cb8e4","161":"79903b61","268":"650b9c2d","912":"6ec493d0","994":"9236c7e7"}[chunkId] + ".chunk.css";
};